// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/chunk." + {"293":"bdb8958e1a2f5498a34a","361":"534e1cbc7acdf1bc6fff","368":"0ee14caa8badffdebeae","494":"609ae602c6bc0537d56e","703":"36876bc3adfad65eb8ae","748":"59d5bd66380729d3b285","815":"d91b9596d99afe813f41","943":"c697d8ab283c61e36956"}[chunkId] + ".js";
};